export const CREATE_EXPERT_BOOKING_REQUEST = "CREATE_EXPERT_BOOKING_REQUEST";
export const CREATE_EXPERT_BOOKING_SUCCESS = "CREATE_EXPERT_BOOKING_SUCCESS";
export const CREATE_EXPERT_BOOKING_FAIL = "CREATE_EXPERT_BOOKING_FAIL";

export const FETCH_MY_EXPERT_BOOKINGS_REQUEST =
  "FETCH_MY_EXPERT_BOOKINGS_REQUEST";
export const FETCH_MY_EXPERT_BOOKINGS_SUCCESS =
  "FETCH_MY_EXPERT_BOOKINGS_SUCCESS";
export const FETCH_MY_EXPERT_BOOKINGS_FAIL = "FETCH_MY_EXPERT_BOOKINGS_FAIL";

export const FETCH_EXPERT_BOOKING_BY_ID_REQUEST =
  "FETCH_EXPERT_BOOKING_BY_ID_REQUEST";
export const FETCH_EXPERT_BOOKING_BY_ID_SUCCESS =
  "FETCH_EXPERT_BOOKING_BY_ID_SUCCESS";
export const FETCH_EXPERT_BOOKING_BY_ID_FAIL =
  "FETCH_EXPERT_BOOKING_BY_ID_FAIL";

export const UPDATE_EXPERT_BOOKING_STATUS_REQUEST =
  "UPDATE_EXPERT_BOOKING_STATUS_REQUEST";
export const UPDATE_EXPERT_BOOKING_STATUS_SUCCESS =
  "UPDATE_EXPERT_BOOKING_STATUS_SUCCESS";
export const UPDATE_EXPERT_BOOKING_STATUS_FAIL =
  "UPDATE_EXPERT_BOOKING_STATUS_FAIL";

export const UPDATE_EXPERT_BOOKING_SCHEDULING_REQUEST =
  "UPDATE_EXPERT_BOOKING_SCHEDULING_REQUEST";
export const UPDATE_EXPERT_BOOKING_SCHEDULING_SUCCESS =
  "UPDATE_EXPERT_BOOKING_SCHEDULING_SUCCESS";
export const UPDATE_EXPERT_BOOKING_SCHEDULING_FAIL =
  "UPDATE_EXPERT_BOOKING_SCHEDULING_FAIL";

export const RESET_EXPERT_BOOKINGS_ERROR = "RESET_EXPERT_BOOKINGS_ERROR";
